module.exports = __webpack_public_path__ + "svg/illustration-team.0b73d95.svg";